import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { SsInventoryService } from 'shared/services/SS-Inventory/ss-inventory.service';
import { environment } from 'environments/environment';
import { GroupService } from 'shared/services/SS-Groups/groups.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppComponent } from 'app/app.component';
import * as _ from 'lodash';
import { AlertPopupService } from 'shared/services/SS-Alert/alert-popup.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DataSharingService } from 'shared/services/data-sharing/data-sharing.service';
import { Params } from '@angular/router/src/shared';

declare var mixpanel; 

@Component({
  selector: 'app-public-group',
  templateUrl: './public-group.component.html',
  styleUrls: ['./public-group.component.scss']
})
export class PublicGroupComponent implements OnInit {
  loading: boolean;
  leagues: any;
  publicGroups: any;
  publicForm: FormGroup;
  imageURL: string = environment.URL_TEAM_IMAGES;
  filterPublicGroups: any = [];
  imgProduct = environment.URL_PRODUCT_IMAGES;
  user: any;

  selectedTeamId;

  params;

  constructor(
    private inventoryService: SsInventoryService,
    private groupService: GroupService,
    private app: AppComponent,
    private alertService: AlertPopupService,
    private data: DataSharingService,
    private router: Router,
    private route: ActivatedRoute,

  ) { }

  ngOnInit() {
    this.loading = true;
    this.app.toggleLoadingMsg('Finding Open Groups');
    this.data.changeTitle('PUBLIC GROUPS');
    this.route.queryParams.subscribe(params => {
      this.params = params;
      this.selectedTeamId = params.team_id;
    });
    this.inventoryService.getPublicInventory().subscribe(res => {
      this.leagues = res.products;
      this.publicForm = new FormGroup({
        team: new FormControl(this.leagues[0].team_id, Validators.required),
        section: new FormControl('', Validators.required),
        price: new FormControl(true, Validators.required)
      });
      this.getPublicGroups();
    }, err => {
      this.app.dismissLoading();
      this.alertService.errorAlertError("Failed to load public groups. Please contact support if this error persists.")
      this.leagues = null;
    });
    mixpanel.track("Viewed public groups listings", {teamId: this.params.team_id})
  }

  getPublicGroups() {
    this.app.toggleLoadingMsg('');
    setTimeout(() => {
      this.groupService.getPublicGroups(this.selectedTeamId).subscribe(res => {
        this.app.dismissLoading();
        this.loading = false;
        this.publicGroups = res.public_groups;
        this.applyInitFilters();
      }, err => {
        this.loading = false;
        this.app.dismissLoading();
      });
    }, 100);

  }

  back() {
    if(environment.IS_WHITE_LABEL==true){
      this.router.navigateByUrl('/new-group');
    } else {
      this.router.navigateByUrl('/new-group/public-groups/choose-team');
    }
  }

  applyInitFilters() {
    const filterGroups = this.publicGroups;
    this.filterPublicGroups = this.publicGroups;
    this.handleUrlFilters(); // apply filters from url, if any
  }

  getActiveFilter() {
    return 1;
  }

  applyFilters() {
    const filterGroups = _.filter(this.publicGroups, publicGroup => {
      return publicGroup.season_ticket.section === this.publicForm.get('section').value;
      /*  && publicGroup.min_split === this.value */
    });
    if (this.publicForm.get('price').value === true) {
      this.filterPublicGroups = _.sortBy(filterGroups, [function (publicGroup) {
        return Number(publicGroup.season_ticket.total_cost);
      }]);
    } else {
      this.filterPublicGroups = _.sortBy(filterGroups, [function (publicGroup) {
        return Number(publicGroup.season_ticket.total_cost);
      }]).reverse();
    }
  }

  filterAll = true;
  all() {
    this.filterAll = !this.filterAll;
    this.filterHiToLow = false
    this.filterLoToHigh = false
    this.filterMixed = false
    this.filterWeekdays = false
    this.filterWeekends = false
    this.filterPublicGroups = this.publicGroups;
    this.resetSplitType();
  }

  filterHiToLow = false;
  hiToLow() {
    this.filterAll = false;
    this.filterHiToLow = !this.filterHiToLow;
    this.filterLoToHigh = false;
    this.resetSplitType()
    this.filterPublicGroups = _.sortBy(this.filterPublicGroups, (oneGroup) => {
      return Number(oneGroup.current_cost);
    }).reverse();
  }

  filterLoToHigh = false;
  lowToHi() {
    this.filterAll = false;
    this.filterLoToHigh = !this.filterLoToHigh;
    this.filterHiToLow = false;
    this.resetSplitType()
    this.filterPublicGroups = _.sortBy(this.filterPublicGroups, (oneGroup) => {
      return Number(oneGroup.current_cost);
    });
  }

  filterWeekends = false
  weekends() {
    this.filterAll = false;
    this.filterWeekends = !this.filterWeekends;
    this.filterWeekdays = false;
    this.filterMixed = false;
    this.resetSplitType()
    this.filterPublicGroups = _.filter(this.publicGroups, (publicGroup) => {
      return publicGroup.filter_flag == "WE";
    });
  }

  filterWeekdays = false;
  weekdays() {
    this.filterAll = false;
    this.filterWeekdays = !this.filterWeekdays
    this.filterWeekends = false;
    this.filterMixed = false;
    this.resetSplitType()
    this.filterPublicGroups = _.filter(this.publicGroups, (publicGroup) => {
      return publicGroup.filter_flag == "WD";
    });
  }
  filterMixed = false;
  mixed() {
    this.filterAll = false;
    this.filterMixed = !this.filterMixed;
    this.filterWeekdays = false;
    this.filterWeekends = false;
    this.resetSplitType()
    this.filterPublicGroups = _.filter(this.publicGroups, (publicGroup) => {
      return publicGroup.filter_flag == "MIX" || publicGroup.filter_flag == null;
    });
  }

  filterDraft = false;
  draft() {
    this.filterDraft = !this.filterDraft;
    this.filterCustom = false;
    this.filterAll = false;
    this.resetDayOfWeek();
    this.filterPublicGroups = _.filter(this.publicGroups, (publicGroup) => {
      return publicGroup.st_type != "UPLOAD-CUSTOM";
    });
  }

  filterCustom = false;
  custom() {
    this.filterCustom = !this.filterCustom;
    this.filterDraft = false;
    this.filterAll = false;
    this.resetDayOfWeek();
    this.filterPublicGroups = _.filter(this.publicGroups, (publicGroup) => {
      return publicGroup.st_type == "UPLOAD-CUSTOM";
    });
  }

  handleUrlFilters() {
    if (this.params.filter_id) {
      let filterCode = this.params.filter_id;
      if (filterCode == "WE")
        this.weekends();
      if (filterCode == "WD")
        this.weekdays();
    }
  }

  resetDayOfWeek() {
    this.filterWeekdays = false;
    this.filterWeekends = false;
    this.filterMixed = false;
  }
  resetSplitType() {
    this.filterDraft = false;
    this.filterCustom = false;
  }
  goToViewDetails(groupId) {
    this.router.navigate(['new-group/public-groups/view-detail'], { queryParams: { groupId: groupId } });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/group/components/public-group/public-group.component.ts